import React, { createContext, useState, useRef, useEffect } from 'react';
import IsTabActive from './IsTabActive';
import gsap from 'gsap';


export const AudioContext = createContext();


export const AudioProvider = ({ children }) => {
    const [isPlaying, setIsPlaying] = useState(false); 
    const [isAnimate, setIsAnimate] = useState(false);
    const isTabVisible = IsTabActive();
    const musicRef = useRef(null)
    const transiRef = useRef(null)
    const btnRef = useRef(null)
    
    useEffect(() => {
        const music = new Audio("/sounds/music.mp3");
        const transi = new Audio("/sounds/transi.mp3");
        const btn = new Audio("/sounds/btn.mp3");
        music.loop = true;
        music.volume = 0; 
        transi.volume = 0; 
        btn.volume = 0;
        musicRef.current = music;
        transiRef.current = transi;
        btnRef.current = btn;

        return () => {
            music.pause();
            musicRef.current = null;
            transi.pause();
            transiRef.current = null;
            btn.pause();
            btnRef.current = null;
        };
    }, [])

    useEffect(() => {
        if (!isTabVisible) {
            const music = musicRef.current;
            setIsPlaying(false);
            music.pause();
        } 
    }, [isTabVisible]); 


    const playMusic = () => {
        const music = musicRef.current;
        if (!isPlaying) {
            music.volume = 0; 
            music.play();
            setIsAnimate(true);
            setIsPlaying(true);
            gsap.to(music, {
                volume: 0.3,
                duration: 1.2, 
            });
            setIsAnimate(false);
        }
    };

    const playTransi = () => {
        if (isPlaying) {
            const transi = transiRef.current;
            transi.volume = 0; 
            transi.play();
            gsap.to(transi, {
                volume: 0.34,
                duration: 1,
            });
        }
    };

    const playStart = () => {
        const transi = transiRef.current;
        transi.volume = 0; 
        transi.play();
        gsap.to(transi, {
            volume: 0.40,
            duration: 1, 
            delay: 1.6,
        });
    };

    const playBtn = () => {
        if (isPlaying) {
            const btn = btnRef.current;
            btn.volume = 0; 
            btn.play();
            gsap.to(btn, {
                volume: 0.5,
                duration: 0, 
            });
        }
    };

    const stopMusic = () => {
        const music = musicRef.current;
        if (isPlaying && !isAnimate) {
            setIsPlaying(false);
            setIsAnimate(true);
            gsap.to(music, {
                volume: 0,
                duration: 1, 
                onComplete: () => {
                    music.pause();
                    music.currentTime = 0; 
                    setIsAnimate(false);
                }
            });
        }
    };

    const changeVolume = (volume) => {
        const music = musicRef.current;
        gsap.to(music, {
            volume: volume,
            duration: 1, 
        });
    };


    return (
        <AudioContext.Provider value={{ isPlaying, playMusic, stopMusic, changeVolume, playTransi, playBtn, playStart }}>
            {children}
        </AudioContext.Provider>
    );
};
